/* 活动相关 */
import { setStorage,  getStorage} from '@/libs/utils';
import _ from 'lodash';
import { activityShow, activityInfo, activityFlashInfo, buttonReport, flashReport, getBoxAdBanner as getBoxAdApi } from '@/api/activity';
import moment from 'moment';
import { buryReportV2 } from '@/libs/business/account';

const state = {
  giftList: [],
  /* sdk活动需求 */
  activity_type: 0,
  activity_show_info: {},
  activity_show: 0,
  flash_show: 0,
  float_background: '',
  activity_info: null,
  bridgeInitFlag: 0,
  flash_info: {},
  server_created_at: '', // 开服时间
  level: '', // 角色等级
  role_id: '', // 角色id
  show_flash_id: [], // 已经展示的闪页id列表
  role_info: {}, // h5用来暂存角色信息
  red_dot_list: [], // 所有红点活动集合，用于清空后消除悬浮球红点
  box_ad_banner: ''
  /* ---------- */
};

const mutations = {
  CHANGE_STATE: (state, obj) => {
    state = Object.assign(state, obj);
  }
};

const actions = {
  /**
   * h5用于存储一个角色下已经展示过的闪页id
   * @param {*} obj.role_id 角色id
   * @param {*} obj.flash_id 当前闪页id
   */
  setFlashId: async ({ state }, obj) => {
    try {
      let flashRecordList = getStorage('h5_flash_record');
      if (flashRecordList) {
        flashRecordList = JSON.parse(flashRecordList);
        if (flashRecordList[obj.role_id]) {
          // 如果当前角色下显示过闪页，做去重添加
          const arr = new Set(flashRecordList[obj.role_id]);
          arr.add(obj.flash_id);
          flashRecordList[obj.role_id] = [...arr];
        } else {
          flashRecordList[obj.role_id] = [obj.flash_id];
        }
      } else {
        flashRecordList = { [obj.role_id]: [obj.flash_id] };
      }
      setStorage('h5_flash_record', JSON.stringify(flashRecordList));
    } catch (error) {}
  },
  /**
   * h5用于获取存储一个角色下已经展示过的闪页id
   * @param {*} obj.role_id 角色id
   */
  getFlashId: async () => {
    let flashRecordList = getStorage('h5_flash_record');
    if (flashRecordList) {
      flashRecordList = JSON.parse(flashRecordList);
    }
  },
  // 活动页选中某个有红点的活动时处理
  setRedDot: async ({ state }, obj) => {
    const { parentIndex, index } = obj;
    let activity_info = _.cloneDeep(state.activity_info);
    let redDotList = _.cloneDeep(state.red_dot_list);
    console.log(state.activity_info)
    let menuItem = activity_info.sum_menu[parentIndex];
    // 处理红点
    console.log(103)
    let activityItem = menuItem.activity[index];
    activityItem.red_notice = 0;
    // 处理分类中红点记录
    console.log(106, menuItem.redDot)
    const redIndex = menuItem.redDot.findIndex((item) => item === index);
    menuItem.redDot.splice(redIndex, 1);

    // 处理总的红点,用于通知客户端是否显示红点
    const redDotIndex = redDotList.findIndex((item) => item === activityItem.activity_id);
    redDotList.splice(redDotIndex, 1);

    state.activity_info = activity_info;
    state.red_dot_list = redDotList;

    // 处理缓存记录
    let redDotHistory = getStorage('red_dot_history') || '{}';
    redDotHistory = JSON.parse(redDotHistory);
    let user_id = getStorage('user_id');
    if (!redDotHistory[user_id]) redDotHistory[user_id] = [];
    redDotHistory[user_id].push(activityItem.activity_id);
    setStorage('red_dot_history', JSON.stringify(redDotHistory));
  },
  /**
   * 获取活动信息接口
   * @param {*} appkey appkey
   * @param {*} user_id 用户ID
   * @param {*} server_created_at 服务器开服日期，例 “2020-05-27”
   * @param {*} level 角色等级
   */
  async getActivityInfo({ commit, rootState }, data) {
    const { user, suspend } = rootState;
    const r = await activityInfo(data || {
      appkey: user.appkey,
      user_id: user.user_id,
      server_created_at: suspend.role.server_created_at,
      level: suspend.role.level || suspend.role.role_level,
      role_id: suspend.role.role_id
    });
    let activity_info = r.content;
    // 获取用户点击过的红点历史
    let redDotHistory = getStorage('red_dot_history') || '';
    let user_id = getStorage('user_id');
    try {
      redDotHistory = JSON.parse(redDotHistory) || {};
      redDotHistory = redDotHistory[user_id] || [];
    } catch (error) {
      redDotHistory = [];
    }
    let redDotList = [];
    activity_info.sum_menu &&
      activity_info.sum_menu.forEach((sumMenu, sumMenuIndex) => {
        let activity = sumMenu.activity || [];
        sumMenu.redDot = [];
        activity.forEach((activityItem, activityIndex) => {
          activityItem.parentIndex = sumMenuIndex;
          activityItem.index = activityIndex;
          if (activityItem.red_notice == 1) {
            if (redDotHistory.includes(activityItem.activity_id)) {
              activityItem.red_notice = 0;
            } else {
              sumMenu.redDot.push(activityItem.activity_id);
              redDotList.push(activityItem.activity_id);
            }
          }
        });
      });
    // console.log(184, activity_info)

    commit('CHANGE_STATE', {
      activity_info,
      red_dot_list: redDotList
    });
  },
  /**
   * 获取闪页信息接口
   * @param {*} appkey appkey
   * @param {*} user_id 用户ID
   * @param {*} server_created_at 服务器开服日期，例 “2020-05-27”
   * @param {*} level 角色等级
   */
  async getFlashInfo({ commit }, data) {
    const r = await activityFlashInfo(data);
    commit('CHANGE_STATE', {
      flash_info: r.content
    });
  },
  /**
   * 日志上报
   * @param {*} type
   */
  report({}, data) {
    switch (data.type) {
      case 'button':
        buttonReport(data)
        break;
      case 'flash':
        flashReport(data)
        break;
      default:
        break;
    }
  },
  // h5判断是否开启sdk活动
  async handleActivityShow({ commit, state, rootState, dispatch }, params) {
    commit('CHANGE_STATE', { role_info: params })
    const flashIdList = getStorage('flashIdList') || '';
    const { user: { appkey, user_id, extra_data, access_token, device_info } } = rootState;
    console.log(JSON.parse(extra_data), device_info)
    const _extraData = JSON.parse(extra_data);
    const r = await activityShow({
      appkey: appkey,
      user_id: user_id,
      server_created_at: params.serverCreatedAt || params.server_created_at ||"",
      level: params.roleLevel || params.level || params.role_level,
      role_id: params.roleId || params.role_id,
      show_flash_id: flashIdList,
      idfv: _extraData.idfv || "",
      access_token: access_token
    });
    if (r.content.timing == 1) {
      let during = moment(r.content.target_online_time).diff(moment(r.content.role_online_time));
      if (during <= 120) during = 120;
      setTimeout(() => {
        dispatch('handleActivityShow', params);
      }, during * 1000);
    }
    commit('CHANGE_STATE', { 
      activity_show_info: {
        ...r.content,
      }
    })
    setTimeout(() => {
      if (r.content.flash === 1) {
        commit('CHANGE_STATE', { 
          activity_show_info: {
            ...r.content,
            visible: true,
          },
          activity_type: 0
        })
      }
      commit('user/CHANGE_STATE', { 
        floatWindowVisible: false
      }, { root: true})
    }, 5000)
    if (r.content.float_type == 3) {
      buryReportV2('SDK_FLOAT_ACTIVITY_EXPOSE', {
        "sum_id": r.content.sum_id,
        "sum_name":r.content.sum_name,
        "activity_id": r.content.activity_id,
        "activity_name": r.content.activity_name,
      })
    }
    return r.content
  },
  async getBoxAdBanner({ commit, state, rootState }) {
    const { user: { appkey } } = rootState
    const r = await getBoxAdApi({ appkey });
    commit('CHANGE_STATE', {
      box_ad_banner: r.content
    })
    
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
